import React, { useState, useEffect } from "react";
import "../styles/Login.css";

import { FaArrowPointer } from "react-icons/fa6";
import { FaMicrosoft } from "react-icons/fa";
import login_image from "../assets/images/rafiki.svg"

import { APIStatus } from "../constants/constant";
import SSOService from "../services/SSOService";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

const Login = () => {
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            const loginResponse = await instance.loginPopup(loginRequest);
            instance.setActiveAccount(loginResponse.account);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="login-container">
            <div className="circle-container">
                <div className="circle large"></div>
                <div className="circle medium"></div>
                <div className="circle small"></div>
            </div>
            <div className="login-block">
                <div className="leftside-block">
                    <div className="introduction">
                        <span className="title">Welcome to MSTeamsTool</span>
                        <span>Easily add multiple members to your Microsoft Teams group in just a few clicks <FaArrowPointer /></span>
                        <img src={login_image} alt="error" />
                    </div>
                </div>
                <div className="rightside-block">
                    <button className="sign-in-button" onClick={() => handleLogin()}>
                        <FaMicrosoft /> SIGN IN
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;
